// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteBoundaryCanvas_wrapper__Hn8-A"};